import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../api-base-url.token';

export interface SensorHistoricalPoint {
  time: string;
  avgIn: number;
  avgOut: number;
  occurrenceCount: number;
  cumulativeOccupancy?: number;
}

export interface SensorHistoricalResponse {
  queueId: string;
  dayOfWeek: number;
  points: SensorHistoricalPoint[];
}

export interface EstablishmentSensorHistoricalResponse {
  establishmentId: string;
  dayOfWeek: number;
  points: SensorHistoricalPoint[];
}

@Injectable({ providedIn: 'root' })
export class SensorHistoricalService {
  private readonly http = inject(HttpClient);
  private readonly base = inject(API_BASE_URL).replace(/\/+$/, '');

  getSensorHistorical(queueId: string, dayOfWeek: number): Observable<SensorHistoricalResponse> {
    return this.http.get<SensorHistoricalResponse>(
      `${this.base}/api/v1/queues/${queueId}/sensor-historical`,
      { params: { dayOfWeek: dayOfWeek.toString() } }
    );
  }

  getSensorHistoricalByEstablishment(establishmentId: string, dayOfWeek: number): Observable<EstablishmentSensorHistoricalResponse> {
    return this.http.get<EstablishmentSensorHistoricalResponse>(
      `${this.base}/api/v1/establishments/${establishmentId}/sensor-historical`,
      { params: { dayOfWeek: dayOfWeek.toString() } }
    );
  }
}
